import { Fragment, memo } from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
//Local files
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import Status from 'components/Common/DataDisplay/Status/Status';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const FillDocList = ({ documents, onDelete, sx }) => {
  return (
    <>
      <Divider sx={{ borderColor: 'border' }} />
      <List
        disablePadding
        sx={{ sx }}
      >
        {documents.map((item) => (
          <Fragment key={item.id}>
            <ListItem
              sx={{
                width: '100%',
                justifyContent: 'space-between',
                gap: { xs: '4px', md: '80px' },
                py: 2
              }}
            >
              <Typography variant='subtitle2' component='div' noWrap sx={{ flexGrow: 1 }}>{item?.filename}</Typography>
              {!!item?.status && <>{item.status === 'error' ? <Status color='error.main' label='Error' /> : <Status color='success.main' label='Uploaded' />}</>}
              {!!onDelete && <IconButton color='error' edge='end' sx={{ flexShrink: 0, my: '-8px' }} onClick={() => onDelete(item.id)}><DeleteIcon /></IconButton>}
            </ListItem>
            <Divider sx={{ borderColor: 'border' }} />
          </Fragment>
        ))}
      </List>
    </>
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillDocList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);